
import './App.css';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Research from './components/Reseach';
import Teaching from './components/Teaching';

function App() {
  return (
    <div className="App">

        <link href="https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;600&display=swap" rel="stylesheet" />
        <Navigation />
        <main className='content'>
           <Header />
           <Research />
           <Teaching />
        </main>
        
    </div>
  );
}

export default App;
